import { connectHits } from "instantsearch.js/es/connectors/index.js";

// Show the suppliers card results
export const chamfrBlogsHits = connectHits((renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions;
  const container = widgetParams.container;

  if (isFirstRender) {
    container.innerHTML = ""; // Clear the container
  }

  // Generate custom HTML without <ol> or <li>
  container.innerHTML = hits
    .map(
      (hit) => `
		<div class="search-results-card blog">
			<div class="search-results-card-details">
				<div class="search-results-card-logo">
					<a href="${hit.url}">
						<img src="${hit.imageURL}" loading="lazy" alt="Article image" />
					</a>
				</div>
				<div class="search-results-card-info">
					<h3 class="search-results-card-info-name">
						<a href="${hit.url}">${hit.title}</a>
					</h3>
					<div class="search-results-card-info-post-meta">
						<div class="post-categories">
							${(hit.post_category || []).join(", ")}
						</div>
						/
						<div class="post-date">
							${new Date(hit.date_timestamp * 1000).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
						</div>
					</div>
					<p class="search-results-card-info-description">
						${hit.description.slice(0, 300) + "..."}
					</p>
				</div>
			</div>
			<div class="search-results-card-actions">
				<a href="${hit.url}" class="btn btn-primary">Read Article</a>
			</div>
		</div>
		`
    )
    .join("");
});
